const messages = {
  ServerError: "can't reach to the server",
};

export default messages;
